module.exports = __webpack_public_path__ + "img/angel-speciaux.f1631d1d.jpg";